import { gql } from '@apollo/client';

import EventActionCardFragments from './EventActionCards/fragments';

import { DealStagesDeal } from './__generated__/fragments';

// Shared by every consumer of this fragment's `state` selection -- centralized here, next to the
// fragment that produces it, instead of each consumer re-deriving an identical alias.
export type DealStagesDeal_state = NonNullable<DealStagesDeal>['state'];

const DEAL_STAGES_FRAGMENT = gql`
  fragment DealStagesDeal on Deal {
    id
    state {
      label
      loanDataVisible
      tooltip
      status
    }
    cards {
      __typename
      title
      ...EventActionCardTimelineCard
    }
  }
  ${EventActionCardFragments.TimelineCard}
`;

const DealStagesFragments = {
  Deal: DEAL_STAGES_FRAGMENT,
};

const GET_DEAL_TIMELINE = gql`
  query GetTimeline($id: ID!) {
    deal(id: $id) {
      id
      ...DealStagesDeal
    }
  }
  ${DealStagesFragments.Deal}
`;

export default DealStagesFragments;
export { GET_DEAL_TIMELINE, DEAL_STAGES_FRAGMENT };
